export const LEGACY_REDIRECTS = {
  "rear-extension-renovation-–-axbridge-somerset": "/services",
  "rear-extension-renovation---axbridge-somerset": "/services",
  "contemporary-rear-extension-bath": "/services",
  "contemporary-rear-extension-kitchen-renovation-in-yatton": "/services",
  "glastonbury-contemporary-extension-renovation": "/services",
  "contemporary-rear-extension-full-home-renovation-in-avonmouth": "/services",
  "rear-extension-kitchen-renovation-in-emersons-green": "/services",
  "contemporary-loft-conversion-garage-annex-–-thornbury-bristol": "/services",
  "contemporary-loft-conversion-garage-annex---thornbury-bristol": "/services",
  "fishponds-contemporary-extension-home-renovation": "/services",
  "modern-wraparound-extension-renovation": "/services",
  "victorian-rear-extension-kitchen-renovation-in-bath": "/services",
  "rear-extension-kitchen-renovation-in-taunton-deane": "/services",
  "rear-extension-contemporary-family-living-space-in-yate": "/services",
  "luxury-home-renovation-open-plan-extension-in-newport": "/services",
  "luxury-rear-extension-open-plan-kitchen-renovation-in-clifton": "/services",
  "contemporary-rear-extension-kitchen-renovation-in-thornbury": "/services",
  "rear-extension-kitchen-full-home-renovation-in-bridgwater": "/services",
  "modern-rear-extension-kitchen-renovation-in-bath": "/services",
  "contemporary-rear-extension-full-home-renovation": "/services",
  "contemporary-extension-full-home-renovation": "/services",
  "extension-and-kitchen-renovation": "/services",
};

export const LEGACY_PAGE_REDIRECTS = {
  "/testimonials": "/",
  "/reviews": "/",
};

export function legacyProjectRedirect(slug) {
  if (!slug) return null;
  const norm = decodeURIComponent(slug).replace(/–/g, "-");
  return LEGACY_REDIRECTS[slug] || LEGACY_REDIRECTS[norm] || null;
}
